<template>
    <div class="printOrder-data" >
        <vue-scroll :ops="$ops">
            <div class="noprint" v-show="printOn">
                <el-button icon="el-icon-printer" v-print="'#print'"
                           size="small">打印合同
                </el-button>
                <div style="    position: absolute;
    right: 140px;
    top: -8px;
    z-index: 1;">
                    <canvas id="msg"></canvas>
                </div>
            </div>
            <div id="print">
                <div id="printArea"
                     class="printableArea"
                     :class="{'ph':!printOn,'show':printOn}"
                     style=";position: relative;">
                    <div style="position: relative" class="invoice-body">
                        <div>
                            <div >
                                <h3 class="title">教学设备借用合同</h3>

                            </div>
                            <div >

                                <p><b>甲方（出借人）：上海墨帝教育科技服务有限公司</b></p>
                                <p><b>乙方（借用人）：方新生</b></p>
                                <p><b>乙方监护人：方父亲</b></p>
                                <p><b>乙方监护人身份证号：232323455683756473</b></p>
                                <p>双方经协商，就乙方借用甲方教学设备达成协议如下，以资共同遵守：</p>
                            </div>
                            <div >
                                <h3>一、设备信息</h3>

                                <p>甲方同意将以下教学设备借给乙方无偿使用：<br>
                                    设备名称：<br>
                                    □	iPad2019 32G Wifi版，序列号<span style="text-decoration: underline"> 3000 </span>元<br>
                                    □	Apple Pencil一代, 序列号<span style="text-decoration: underline"> 221 </span>元<br>
                                </p>

                                <p>
                                    设备价值<span style="text-decoration: underline"> 3221 </span>元。<br>
                                    （以下简称设备）<br>
                                </p>
                            </div>
                            <div >
                                <h3>二、借用期限</h3>
                                <p> 1.自<span style="text-decoration: underline"> 2020 </span>年<span style="text-decoration: underline"> 02 </span>月<span style="text-decoration: underline"> 09 </span>日至乙方2020寒假班及2020春季班线上授课结束。<br>
                                    2.甲方情况变化的，可提前5日通知乙方取消借用，乙方应及时归还设备。<br>
                                    3.乙方到期未归还，或根据本合同预定提前终止借用而不归还的，乙方应按每天设备价值的1%支付设备占用费，直至乙方归还设备为止。<br>
                                </p>
                            </div>
                            <div >
                                <h3>三、双方权利义务</h3>
                                <p> 1.甲方保证借出的设备符合教学要求。<br>
                                    2.乙方接收设备时应对设备进行检查并确认设备质量状况良好，如有异议应在接收设备当时提出。<br>
                                    3.设备由乙方本人使用期间，未经甲方同意，不得买卖、抵押、质押、转租、转借借用设备。乙方做好设备的保管，防止被盗、防止人为损坏。<br>
                                    4.乙方承担因不当使用或过失造成的借用设备维修责任。<br>
                                    5.如乙方在使用过程中，违反本合同规定的，甲方有权在任何时候收回设备，终止合同，并对乙方收取相应的赔偿费。<br>
                                    6.乙方归还设备时，应清除设备内账户信息及保证设备状况良好可正常使用。<br>
                                    7.设备报废或无法归还，乙方应负赔偿责任时，应按本合同第一条约定的设备价值进行赔偿。<br>
                                </p>

                            </div>
                            <div >
                                <h3>四、争议解决</h3>
                                <p>因本合同引起的或与本合同有关的任何争议，由合同各方协商解决，也可由有关部门调解。协商或调解不成的，应向本合同签订地有管辖权的人民法院起诉。</p>
                            </div>
                            <div >
                                <h3>五、附则</h3>
                                <p>本合同一式两份，合同各方各执一份；本合同经各方签署后生效。</p>

                            </div>
                            <div >
                                <p>签署地点：上海市青浦区</p>
                                <p>签署日期： 2020 年  02 月 10 日</p>
                            </div>
                            <div style="float: left;width: 60%">
                                <p>甲方签章：</p>
                                <p>联系方式：</p>
                            </div>
                            <div style="float: left;">
                                <p>乙方监护人签字：</p>
                                <p>联系方式：</p>
                            </div>

                            <div style="clear: both"></div>
                        </div>
                    </div>
                </div>
            </div>
        </vue-scroll>

    </div>
</template>
<style lang="scss">
    #msg{
        width:100px !important;
        height:100px !important;
    }
    .show {
        overflow: auto;
    }

    .ph {
        height: 100% !important;
    }

    .printableArea {
        padding: 10px 20px;
        color: #000 !important;
        font-weight: 500;
    }

    .printableArea .invoiceNumber{
        position:absolute;right:30px;font-size:10px;color:rgba(120, 130, 140, 0.74);
    }
    .printableArea .title{
        margin-top: 0;line-height: 30px;font-size: 18px;font-weight: 500;text-align: center;
    }
    .printableArea h3 {
        line-height: 30px;
        font-size: 15px;
        font-weight: 500;
    }

    .printableArea p {
        font-size: 12px;
        padding-left: 15px;
        padding-right: 15px;
    }

    .printableArea table {
        font-size: 12px;
        border-color: #000;
    }

    .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
    .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
    .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
        border: 1px solid #000 !important;
        color: #000;
        font-size: 12px;
        font-weight: 500 !important;
    }

    .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
        padding: 7px 9px;
    }

    .printableArea .table-responsive {
        padding: 0 15px;
    }

    .printableArea .page-break{
        page-break-before: always  !important;
    }

    @media print{
        #print {
            .printableArea {
                padding: 0 !important;
                color: #000 !important;
                font-weight: 500;

            }

            .invoice-body{
                page-break-before:always;
            }

            .printableArea .title{
                margin-top: 0;
                line-height: 40px;
                font-size: 25px;
                font-weight: 500;
                text-align: center;

            }
            .printableArea .invoiceNumber{
                position:absolute;right:30px;font-size:15px;color:rgba(120, 130, 140, 0.74);
            }

            .printableArea h3 {
                line-height: 30px;
                font-size: 21px;
                font-weight: 500;
            }


            .printableArea p {
                font-size: 18px;
                padding-left: 15px;
                padding-right: 15px;
            }

            .printableArea table {
                font-size: 18px;
                border-color: #000;
            }

            .printableArea .table-bordered > tbody > tr > td, .printableArea .table-bordered > tbody > tr > th,
            .printableArea .table-bordered > tfoot > tr > td, .printableArea .table-bordered > tfoot > tr > th,
            .printableArea .table-bordered > thead > tr > td, .printableArea .table-bordered > thead > tr > th {
                border: 1px solid #000 !important;
                color: #000;
                font-size: 18px;
                font-weight: 500 !important;
            }

            .printableArea .table > tbody > tr > td, .printableArea .table > tbody > tr > th, .printableArea .table > tfoot > tr > td, .printableArea .table > tfoot > tr > th, .printableArea .table > thead > tr > td, .printableArea .table > thead > tr > th {
                padding: 7px 9px;
            }

            .printableArea .table-responsive {
                padding: 0 15px;
            }

            .printableArea .page-break{
                page-break-before: always  !important;
            }
        }
    }
</style>
<script>
    export default {
        name: 'Dialog_BorrowingOfTeachingEquipment',
        data() {
            return {
                QRCodeMsg:'234',
                printOn:true
            };
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        created() {
            //this.handleInvoiceDetail()
        },
        mounted(){
        },
        methods: {
            handleInvoiceDetail() {
                this.$wApi.send(this.$parentInfo.path, 'anotherInvoiceDetail', {
                    'invoice_id': this.$store.state.modal.data.invoice_id,
                });
            },

        }
    };
</script>
